import ButtonActionDetailGroup from "../../../common/ButtonActionDetailGroup";
import React, { useState } from "react";
import { ConfirmResendEmailDialog } from "../../../common/ConfirmResendEmailDialog";
import { TransactionStatus } from "../../../../constants/TransactionConstants";
import {
  AuthenticationManager,
  ResourceID,
} from "../../../../common/AuthenticationManager";
import { ApplicationID } from "../../../../common/Constants";

const PWSM = ApplicationID.getName(ApplicationID.PWSM);
const GPAY = ApplicationID.getName(ApplicationID.GPAY);
export default function EmailResending(props) {
  const { transaction } = props;
  const [showConfirmResendEmail, setShowConfirmResendEmail] = useState(false);

  const onHideConfirmResendEmail = () => {
    setShowConfirmResendEmail(false);
  };

  const isShowResendEmailButton =
    (transaction.salesChannel === PWSM || transaction.salesChannel === GPAY) &&
    transaction.status === TransactionStatus.Successful &&
    AuthenticationManager.isAuthorized(ResourceID.ResendConfirmationEmail);

  return (
    <>
      {isShowResendEmailButton && (
        <ButtonActionDetailGroup.Item
          className="btn btn-primary"
          onClick={() => setShowConfirmResendEmail(true)}
        >
          Resend Email
        </ButtonActionDetailGroup.Item>
      )}
      {showConfirmResendEmail && (
        <ConfirmResendEmailDialog
          onCancel={onHideConfirmResendEmail}
          transaction={transaction}
          showConfirmResendEmail={showConfirmResendEmail}
        />
      )}
    </>
  );
}
